import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-49",
  "use": "icon-icon-nav-49-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-49\"><path d=\"M796.416 547.584H227.584A35.648 35.648 0 0 0 192 583.04v213.312c0 19.584 16 35.584 35.584 35.584h568.832c19.584 0 35.584-16 35.584-35.584V583.104a35.648 35.648 0 0 0-35.584-35.52z m-462.208 213.312c-39.04 0-71.04-32-71.04-71.104s32-71.104 71.04-71.104c39.104 0 71.104 32 71.104 71.04 0 39.168-32 71.168-71.04 71.168zM796.416 192H227.584A35.648 35.648 0 0 0 192 227.584v213.312c0 19.52 16 35.52 35.584 35.52h568.832c19.584 0 35.584-16 35.584-35.52V227.584A35.648 35.648 0 0 0 796.416 192zM334.208 405.312c-39.04 0-71.04-32-71.04-71.04 0-39.168 32-71.168 71.04-71.168 39.104 0 71.104 32 71.104 71.104s-32 71.104-71.04 71.104z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-49.svg
// module id = tes0
// module chunks = 3